const ADD_AGENCE = {
  title: 'Créer une agence',
  titleModification: 'Modifier une agence',
  tab: {
    agence: 'Agence',
    edition: 'Edition',
  },
  informationsAgences: {
    title: 'Informations agence',
    code: 'Code agence',
    societeAssocie: 'Société associée',
    libelle: 'Libellé agence',
    email: 'Email principal',
    telephone: 'Téléphone',
    fax: 'Fax',
  },
  adresse: 'Adresse de l\'agence',
  adresseIntitule: 'Adresse',
  signataire: {
    title: 'Signataires',
  },
  infoComplementaire: {
    title: 'Informations complémentaires',
    prefixeCodeFacture: 'Préfixe code facture',
    suffixeCodeFacture: 'Suffixe code facture',
    codeMetier: 'Code métier',
    codeSite: 'Code site',
    domiciliationBancaire: 'Domiciliation bancaire',
    regimeTva: 'Régime TVA par défaut',
  },
  piedPageDoc: 'Pied de page des documents',
  emailFacturation: 'E-mail facturation',
  saisirMailFacturation: 'Configurer un e-mail pour l\'envoi de facture',
  saisirPiedPage: 'Configurer un pied de page',
  success: {
    add: 'L\'agence a été ajoutée avec succès.',
    update: 'L\'agence a été modifiée avec succès.',
  },
  error: {
    libelle: 'Le libelle de l\'agence est obligatoire',
    domiciliationBancaire: 'La domiciliation bancaire de l\'agence est obligatoire',
    codeAgence: 'Le code agence de l\'agence est obligatoire et il doit faire entre 1 et 5 caractères',
    suffixeCodeFacture: 'Le champ suffixe code facture doit comporter maximum 10 caractères',
  },
  editionBat: {
    titleModification: 'Modifier édition BAT',
    texteBasEditionBat: 'Texte en bas à droite',
    informations: 'Informations générale',
    couleurEditionBat: 'Couleur',
  },
  mailBat: {
    titleModification: 'Modifier mail BAT',
    tab: {
      emailBat: 'Mail BAT',
      emailDemandeVisuel: 'Mail demande visuel',
      emailTransmisPAO: 'Mail transmis PAO',
      emailValidationVRP: 'Mail validation VRP',
    },
    emailDemandeVisuel: 'Mail demande de visuel',
    emailBat: 'Mail BAT',
    informations: 'Informations générale',
  },
};

export default ADD_AGENCE;
